class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.interval = null;
    this.announcementHeight = 30;

    this.container = this.querySelector("#wt-announcement__container");
    this.items = this.container
      ? Array.from(this.container.children)
      : [];

    this.showNext = this.showNext.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.updateAnnouncementHeight = this.updateAnnouncementHeight.bind(this);
  }

  connectedCallback() {
    if (!this.container || !this.items.length) return;

    // Add body class when announcement bar is active
    document.body.classList.add('has-announcement');

    // Set up dynamic height calculation based on scroll
    this.updateAnnouncementHeight();
    window.addEventListener('scroll', this.updateAnnouncementHeight, { passive: true });

    // Show first item
    this.items.forEach((item, i) =>
      item.classList.toggle("is-active", i === 0)
    );

    // Start loop only if there's more than one item
    if (this.items.length > 1) {
      this.interval = setInterval(this.showNext, 4000);
    }

    // Close button
    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.hideForOneDay);
    }

    this.startCountdowns();
  }

  showNext() {
    const current = this.items[this.currentIndex];
    current.classList.remove("is-active");

    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      const next = this.items[this.currentIndex];
      next.classList.add("is-active");
    }, 800);
  }

  updateAnnouncementHeight() {
    const scrollY = window.scrollY || window.pageYOffset;
    const height = Math.max(0, this.announcementHeight - scrollY);
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  }

  startCountdowns() {
    const items = this.querySelectorAll('[data-countdown-target]');
    if (!items.length) return;

    const pad = n => String(Math.floor(n)).padStart(2, '0');

    const tick = () => {
      items.forEach(item => {
        const target = new Date(item.dataset.countdownTarget).getTime();
        const diff = target - Date.now();

        const days = item.querySelector('.wt-countdown__days');
        const hours = item.querySelector('.wt-countdown__hours');
        const minutes = item.querySelector('.wt-countdown__minutes');
        const seconds = item.querySelector('.wt-countdown__seconds');

        if (diff <= 0) {
          if (days) days.textContent = '00';
          if (hours) hours.textContent = '00';
          if (minutes) minutes.textContent = '00';
          if (seconds) seconds.textContent = '00';
          return;
        }

        if (days) days.textContent = pad(diff / 86400000);
        if (hours) hours.textContent = pad((diff % 86400000) / 3600000);
        if (minutes) minutes.textContent = pad((diff % 3600000) / 60000);
        if (seconds) seconds.textContent = pad((diff % 60000) / 1000);
      });
    };

    tick();
    this.countdownInterval = setInterval(tick, 1000);
  }

  hideForOneDay() {
    const oneDayLater = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
    document.body.classList.remove('has-announcement');
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    window.removeEventListener('scroll', this.updateAnnouncementHeight);
    clearInterval(this.interval);
    clearInterval(this.countdownInterval);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    clearInterval(this.countdownInterval);
    window.removeEventListener('scroll', this.updateAnnouncementHeight);
  }
}

customElements.define("announcement-bar", AnnouncementBar);

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>

    customElements.define("announcement-bar", AnnouncementBar)

  );
  document.addEventListener("shopify:section:reorder", () =>
    customElements.define("announcement-bar", AnnouncementBar)
  );
}
